/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {AppSharedModule} from '../../common/app-shared.module';

@Component({
  standalone: true,
  imports: [AppSharedModule],
  selector: 'adn-custom-event-conversion-type',
  template: `@if (conversionType) { <span>{{ ('customEvent.conversionType.' + conversionType) | ogTranslate }}</span> }`
})
export class CustomEventConversionTypeLabelComponent {
  @Input() conversionType: string;
}
